var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    { staticClass: "primary-border-dark", attrs: { view: "hhh lpr fff" } },
    [
      _c(
        "q-layout-header",
        [
          _c(
            "q-toolbar",
            { staticClass: "q-pa-md", attrs: { color: "primary" } },
            [
              _c(
                "q-btn",
                {
                  attrs: { flat: "", dense: "", round: "" },
                  on: {
                    click: function($event) {
                      _vm.leftDrawerOpen = !_vm.leftDrawerOpen
                    }
                  }
                },
                [_c("q-icon", { attrs: { name: "menu" } })],
                1
              ),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                Associated General Contractors of Minnesota\n            "
                )
              ]),
              _c("div", { staticClass: "block q-mt-sm" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c("div", { staticClass: "col" }),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [_c("account-modal", { attrs: { value: _vm.user } })],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col on-left on-right" },
                    [
                      _c("q-btn", {
                        attrs: {
                          dense: "",
                          round: "",
                          flat: "",
                          icon: "exit_to_app"
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.logout.apply(null, arguments)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-layout-drawer",
        {
          attrs: {
            breakpoint: 1200,
            "content-class": "bg-grey-3",
            mini: _vm.mini
          },
          model: {
            value: _vm.leftDrawerOpen,
            callback: function($$v) {
              _vm.leftDrawerOpen = $$v
            },
            expression: "leftDrawerOpen"
          }
        },
        [
          _c(
            "div",
            { staticClass: "bg-blue-grey-9 text-center q-pa-md text-white" },
            [_vm._v("\n            Admin Navigation\n        ")]
          ),
          _vm._l(_vm.routeNodes, function(item, index) {
            return _c("sidebar-nav", { key: index, attrs: { item: item } })
          })
        ],
        2
      ),
      _c(
        "q-page-container",
        [
          _c(
            "q-toolbar",
            { attrs: { color: "blue-grey-1" } },
            [_c("breadcrumbs", { attrs: { routes: [] } })],
            1
          ),
          _c("router-view")
        ],
        1
      ),
      _c(
        "q-page-sticky",
        { attrs: { position: "bottom-right", offset: [18, 18] } },
        [
          _c("q-btn", {
            directives: [{ name: "back-to-top", rawName: "v-back-to-top" }],
            attrs: { round: "", color: "secondary", icon: "keyboard_arrow_up" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }